import { render } from "./AddModeleSignatairePage.vue?vue&type=template&id=5c34a8ea&ts=true"
import script from "./AddModeleSignatairePage.vue?vue&type=script&lang=ts"
export * from "./AddModeleSignatairePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__